import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { ReportConfigurationService } from 'app/infrastructure/services/reportConfiguration.service';
import { TemplateListadoItem } from 'app/infrastructure/model/classes/templateListadoItem.class';

@Component({
    selector: 'sx-list-report-configuration',
    templateUrl: './list.report.configuration.component.html',
})
export class ListReportConfigurationComponent implements OnInit {
    systemCode: string;
    businessCode: string;
    reports: Observable<TemplateListadoItem[]>;

    constructor(
        private aRoute: ActivatedRoute,
        private reportService: ReportConfigurationService,
    ) { }

    ngOnInit() {
        this.aRoute.params.subscribe((params: Params) => {
            this.systemCode = params['codsistema'];
            this.businessCode = params['codnegocio'];
            this.reports = this.reportService.getTemplateList(this.systemCode, this.businessCode);
        });
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/reportConfiguration/list.report.configuration.component.ts